import { useEffect } from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';

export const GoogleAdsInit: React.FC = () => {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (import.meta.env.DEV && !import.meta.env.VITE_GOOGLE_ADS_ENABLED) {
      return;
    }

    const adsId = import.meta.env.VITE_GOOGLE_ADS_ID;
    if (!adsId) {
      return;
    }

    if (!hasConsent('analytics')) {
      return;
    }

    if (window.__GOOGLE_ADS_INITIALIZED__) {
      return;
    }
    window.__GOOGLE_ADS_INITIALIZED__ = true;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${adsId}`;
    document.head.appendChild(script);

    const dataLayer = window.dataLayer || [];
    window.dataLayer = dataLayer;
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', adsId);
  }, [hasConsent]);

  return null;
};

export const trackGoogleAdsSignupConversion = (): void => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  const conversionLabel = import.meta.env.VITE_GOOGLE_ADS_SIGNUP_LABEL;
  if (!conversionLabel) {
    return;
  }

  window.gtag('event', 'conversion', {
    send_to: conversionLabel,
  });
};

declare global {
  interface Window {
    __GOOGLE_ADS_INITIALIZED__?: boolean;
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}
